export default __webpack_public_path__ + "assets/images/c397602fd77cad1756c7ec0a2aed8fe5.jpg";